export default __webpack_public_path__ + "static/media/card.42ad6e67.svg";